import React from 'react';
import { MainContainer } from '../MainRoute.styles';
import HeroSection from './HeroSection/Hero.component';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import FourItems from './FourItems/FourItems.component';
import ServicesSection from './Services/Services.component';
import ContactSection from './Contact/Contact.component';
import MissionStatement from './Mission/Mission.component';
import NewsletterSignup from '../../Newsletter/NewsletterSignup.component';
import ProductsSection from './Products/Products.component';

const Home = () => {
  return (
    <MainContainer>
      <HelmetHelper
        title="Online Safety Training & Workplace Safety Solutions"
        description="Online safety training, workplace safety solutions, safety supplies, audits, digital safety forms, manuals, and compliance support for businesses across Atlantic Canada."
        schema={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Yoda Safety Solutions',
          description:
            'Online safety training, workplace safety solutions, safety supplies, audits, digital safety forms, manuals, and compliance support for businesses across Atlantic Canada.',
          url: 'https://yodasafetyservices.com',
        }}
      />
      <HeroSection />
      <FourItems />
      <MissionStatement />
      <ProductsSection />

      <ServicesSection />
      <ContactSection />
      <NewsletterSignup />
    </MainContainer>
  );
};

export default Home;
